import * as React from "react";

import ReactDatetime from "react-datetime";
import moment from "moment";
import "moment/dist/locale/ja";
import { getStore } from "../../store";
import I18n from "lib/I18n";
type Moment = moment.Moment;

function clampMoment(time: string | Moment): Moment {
  return (typeof time === "string" ? moment(time) : time).set({
    minute: 0,
    second: 0,
    millisecond: 0,
  });
}

export function App() {
  const store = getStore();

  const formatMoment = (time: string | Moment): string => {
    return clampMoment(time).format(
      `${store.dateFormat ?? ""} ${store.timeFormat ?? ""}`,
    );
  };

  const onChangeTime = (time: React.FocusEvent<unknown> | string | Moment) => {
    if (typeof time === "string" || moment.isMoment(time)) {
      store.value = formatMoment(time);
    }
  };

  return (
    <div>
      <ReactDatetime
        locale={I18n.locale}
        inputProps={{ name: store.inputName }}
        initialValue={store.value ? moment(store.value).toDate() : undefined}
        onClose={onChangeTime}
        dateFormat={store.dateFormat}
        timeFormat={store.timeFormat}
        strictParsing
      />
    </div>
  );
}
